function Footer() {
	return (
		<footer className="bg-gradient-to-b from-gray-900  to-black text-white text-center py-4 quicksand h-full">
			<p>
				&copy; {new Date().getFullYear()} Pl4no-B
				<br />
				All rights reserved.
			</p>
		</footer>
	)
}

export default Footer
